const paragraph = (text) => ({ type: 'paragraph', text });
const heading = (text) => ({ type: 'heading', text });
const unorderedList = (items) => ({ type: 'unordered-list', items });
const steps = (items) => ({ type: 'steps', items });
const table = (headers, rows) => ({ type: 'table', headers, rows });

// 各平台落地页 Hero 右侧配图
const platformHeroImages = {
	mac: require('@/assets/vpn/platforms/mac-hero.webp'),
	linux: require('@/assets/vpn/platforms/linux-hero.webp'),
	ios: require('@/assets/vpn/platforms/iphone-hero.webp'),
	android: require('@/assets/vpn/screenshot-3.webp'),
};

const platformHeroImage = (key) => platformHeroImages[key];

export const secureVpnPlatformPages = {
	mac: {
		key: 'mac',
		title: 'Secure VPN Download for macOS \u2013 Free VPN for Mac',
		description:
			'Download Secure VPN for macOS and connect your Mac to a fast, private VPN. Learn how to install Secure VPN on Mac and protect your connection.',
		keywords: 'Secure VPN macOS, VPN for Mac, macOS VPN download, free VPN for Mac',
		hero: {
			title: 'Secure VPN for macOS',
			subtitle: 'A simple, privacy-focused VPN for Mac',
			description:
				'Connect your Mac to a secure VPN connection and browse the internet with greater privacy. VPN Free provides an easy way to use a VPN on macOS without complicated setup.',
			ctaLabel: 'Get VPN for Mac',
			secondaryCta: {
				label: 'How to Install',
				href: '#how-to-download-vpn-for-mac',
			},
			image: platformHeroImage('mac'),
			imageAlt: 'Secure VPN connected on macOS',
		},
		sections: [
			{
				id: 'secure-vpn-download-for-mac',
				title: 'Secure VPN Download for Mac',
				blocks: [
					paragraph(
						'Looking for a secure VPN for your Mac? VPN Free offers a straightforward VPN experience designed for macOS users.'
					),
					paragraph(
						"Whether you're using your Mac at home, at work, or on public Wi-Fi, a VPN can help protect your connection by encrypting your internet traffic and masking your IP address."
					),
					paragraph(
						'Download the VPN app for macOS and follow a few simple steps to get connected.'
					),
				],
			},
			{
				id: 'why-use-a-vpn-on-macos',
				title: 'Why Use a VPN on macOS?',
				intro:
					'Using a VPN on your Mac can be useful when you connect to unfamiliar networks or want more privacy while browsing.',
				blocks: [
					heading('Protect Your Connection'),
					paragraph(
						'A VPN encrypts traffic between your Mac and the VPN server, helping reduce the exposure of your internet activity on unsecured networks.'
					),
					heading('Keep Your IP Private'),
					paragraph(
						"Your regular IP address can reveal information about your network connection. A VPN replaces it with the address of the VPN server while you're connected."
					),
					heading('Browse More Privately'),
					paragraph(
						'VPN Free is designed with privacy in mind, giving Mac users another layer of protection for everyday internet use.'
					),
					heading('Secure Public Wi-Fi'),
					paragraph(
						'Coffee shops, airports, hotels, and other public locations often provide shared Wi-Fi. A VPN can add an additional layer of protection when using these networks.'
					),
				],
			},
			{
				id: 'vpn-free-for-macos-features',
				title: 'VPN Free for macOS Features',
				blocks: [
					table(
						['Feature', 'Details'],
						[
							['macOS Support', 'Designed for Mac computers'],
							['Secure Connection', 'Encrypts your VPN connection'],
							['Privacy Protection', 'Helps hide your IP address'],
							['Simple Setup', 'Easy installation and connection'],
							['Free VPN', 'Use the VPN without a paid subscription'],
							['Multiple Locations', 'Connect through available VPN servers'],
							['No Complicated Settings', 'Connect with a simple interface'],
						]
					),
				],
			},
			{
				id: 'how-to-download-vpn-for-mac',
				title: 'How to Download VPN for Mac',
				intro: "Getting started doesn't require complicated configuration.",
				blocks: [
					steps([
						{
							title: 'Download the macOS VPN',
							text: 'Click the Download VPN for Mac button above to get the available Mac version.',
							html: 'Click the <strong>Download VPN for Mac</strong> button above to get the available Mac version.',
						},
						{
							title: 'Install the Application',
							text: 'Open the downloaded installer and follow the installation instructions on your Mac.',
						},
						{
							title: 'Launch VPN Free',
							text: 'After installation, open the VPN application from your Applications folder.',
						},
						{
							title: 'Choose a Server',
							text: 'Select an available VPN location based on your connection needs.',
						},
						{
							title: 'Connect',
							text: 'Click the connect button and wait for the VPN connection to become active.',
						},
					]),
					paragraph(
						'Once connected, your Mac will use the VPN connection for supported internet traffic.'
					),
				],
			},
			{
				id: 'is-vpn-free-available-for-mac',
				title: 'Is VPN Free Available for Mac?',
				blocks: [
					paragraph(
						'Yes. VPN Free provides a dedicated experience for macOS users, allowing you to connect your Mac through a VPN without manually configuring a third-party VPN service.'
					),
					paragraph(
						'The Mac version is intended to keep the setup process simple while providing the core privacy and connection features users expect from a VPN.'
					),
				],
			},
			{
				id: 'vpn-for-mac-vs-browser-vpn',
				title: 'VPN for Mac vs. Browser VPN',
				blocks: [
					paragraph(
						"A browser extension and a system-level VPN don't work in exactly the same way."
					),
					paragraph(
						'A browser VPN generally protects traffic from the supported browser, while a VPN application for macOS can provide VPN protection for network traffic from other applications as well.'
					),
					paragraph(
						'If you regularly use different browsers, desktop applications, or other internet-connected software on your Mac, a dedicated macOS VPN can be more convenient.'
					),
				],
			},
			{
				id: 'secure-vpn-for-everyday-mac-use',
				title: 'Secure VPN for Everyday Mac Use',
				blocks: [
					paragraph('A VPN can be useful in several everyday situations:'),
					unorderedList([
						'Connecting to public Wi-Fi',
						'Working remotely',
						'Browsing from hotels or airports',
						'Protecting traffic on shared networks',
						'Keeping your IP address private',
						'Adding privacy to everyday internet use',
					]),
					paragraph(
						'VPN Free is designed to make these situations easier without requiring users to work through complicated VPN configurations.'
					),
				],
			},
		],
		faqs: [
			{
				question: 'Is VPN Free free on macOS?',
				answer:
					'VPN Free is designed to provide a free VPN option for Mac users. Available features and server options may depend on the current service configuration.',
			},
			{
				question: 'How do I install a VPN on Mac?',
				answer:
					'Download the macOS VPN application, open the installer, complete the installation, and launch the application. You can then select a server and connect.',
			},
			{
				question: 'Does a VPN protect my Mac?',
				answer:
					'A VPN can encrypt your VPN connection and help protect your internet traffic while connected. It does not replace antivirus software or other security protections.',
			},
			{
				question: 'Can I use a VPN on public Wi-Fi?',
				answer:
					'Yes. Using a VPN on public Wi-Fi can add an additional layer of protection by encrypting your connection.',
			},
			{
				question: 'Do I need technical knowledge to use a VPN on Mac?',
				answer:
					'No. A dedicated VPN application can make connecting much easier than manually configuring VPN settings.',
			},
		],
	},
	linux: {
		key: 'linux',
		title: 'Secure VPN Download for Linux \u2013 Free VPN for Linux',
		description:
			'Download Secure VPN for Linux and protect your internet connection with a private VPN. Get setup instructions and learn how to connect Secure VPN on Linux.',
		keywords: 'Secure VPN Linux, VPN for Linux, Linux VPN download, Secure VPN Ubuntu',
		hero: {
			title: 'Secure VPN Download for Linux',
			description:
				'Secure VPN for Linux provides a simple way to connect your computer to a private VPN server. Download the available Linux version, complete the setup, choose a server location, and connect.',
			descriptionHtml:
				'<strong>Secure VPN for Linux provides a simple way to connect your computer to a private VPN server. Download the available Linux version, complete the setup, choose a server location, and connect.</strong>',
			ctaLabel: 'Get Secure VPN for Linux',
			image: platformHeroImage('linux'),
			imageAlt: 'Secure VPN app on Linux',
		},
		sections: [
			{
				id: 'secure-vpn-for-linux',
				title: '',
				blocks: [
					paragraph(
						'Linux gives users plenty of control over their operating system and network configuration, but setting up a VPN manually can still take time.'
					),
					paragraph(
						'Secure VPN offers a simpler option for Linux users who want to route their internet connection through a VPN server without building a configuration from scratch.'
					),
					paragraph(
						"Whether you're using Linux on a desktop, laptop, or another compatible computer, a VPN can add an extra layer of privacy when browsing the web or connecting through shared networks."
					),
				],
			},
			{
				id: 'why-use-secure-vpn-on-linux',
				title: 'Why Use Secure VPN on Linux?',
				blocks: [
					heading('Protect Your Internet Connection'),
					paragraph(
						"A VPN creates an encrypted connection between your Linux device and the VPN server. This can help protect your traffic when using networks that you don't fully control."
					),
					heading('Hide Your Public IP'),
					paragraph(
						"When connected to Secure VPN, websites and online services see the VPN server's public IP address instead of your normal connection IP."
					),
					heading('Safer Public Wi-Fi'),
					paragraph(
						'Linux laptops are often used while traveling, studying, or working remotely. Connecting through a VPN can provide additional protection when using public Wi-Fi.'
					),
					heading('Choose a VPN Server'),
					paragraph(
						'Secure VPN provides access to multiple server locations, allowing you to select an available location when establishing your connection.'
					),
				],
			},
			{
				id: 'secure-vpn-linux-features',
				title: 'Secure VPN Linux Features',
				blocks: [
					table(
						['Feature', 'Details'],
						[
							['Linux Support', 'VPN access for compatible Linux systems'],
							['Encrypted Connection', 'Helps protect traffic while connected'],
							['IP Address Protection', 'Masks your public IP through the VPN'],
							['Multiple Locations', 'Choose from available VPN servers'],
							['Simple Setup', 'Designed to reduce configuration work'],
							['Privacy Focused', 'Adds another layer to your online privacy'],
							['Public Wi-Fi Support', 'Useful on shared and unsecured networks'],
						]
					),
				],
			},
			{
				id: 'how-to-download-secure-vpn-for-linux',
				title: 'How to Download Secure VPN for Linux',
				intro:
					'Getting Secure VPN running on Linux depends on the available Linux package and your distribution.',
				blocks: [
					steps([
						{
							title: 'Download the Linux Version',
							text: 'Click the Download Secure VPN for Linux button to access the available Linux version.',
							html: 'Click the <strong>Download Secure VPN for Linux</strong> button to access the available Linux version.',
						},
						{
							title: 'Check Your Linux Distribution',
							text: 'Before installing the application, check which Linux distribution and architecture your computer uses. Ubuntu, Debian, Fedora, Linux Mint, and other distributions can use different package formats and installation commands.',
						},
						{
							title: 'Install the VPN',
							text: 'Open the downloaded package or follow the installation instructions provided with the Linux version. If the package requires terminal commands, use the commands specified for your particular distribution.',
						},
						{
							title: 'Launch Secure VPN',
							text: 'After installation, open Secure VPN from your application menu or launch it using the appropriate Linux command.',
						},
						{
							title: 'Select a Server',
							text: 'Choose an available VPN location from the server list.',
						},
						{
							title: 'Connect',
							text: 'Click Connect and wait until the VPN connection is established.',
							html: 'Click <strong>Connect</strong> and wait until the VPN connection is established.',
						},
					]),
					paragraph(
						'Your Linux computer can then use the VPN connection for supported internet traffic.'
					),
				],
			},
			{
				id: 'secure-vpn-on-ubuntu-and-other-linux-distributions',
				title: 'Secure VPN on Ubuntu and Other Linux Distributions',
				blocks: [
					paragraph(
						"Linux is available in many different distributions, and the installation process isn't always identical."
					),
					paragraph(
						"Secure VPN users may encounter different setup steps depending on whether they're running:"
					),
					unorderedList([
						'Ubuntu',
						'Debian',
						'Linux Mint',
						'Fedora',
						'Arch Linux',
						'Other compatible Linux distributions',
					]),
					paragraph(
						"Always check the requirements for the specific Secure VPN Linux package before installing it. If your distribution isn't supported by the available application, manual VPN configuration may be another option."
					),
				],
			},
			{
				id: 'vpn-application-or-manual-linux-configuration',
				title: 'VPN Application or Manual Linux Configuration?',
				blocks: [
					paragraph(
						'Linux users often have two ways to establish a VPN connection: using a dedicated application or configuring the VPN manually.'
					),
					table(
						['', 'Secure VPN App', 'Manual VPN Setup'],
						[
							['Setup', 'Guided installation', 'Configuration required'],
							['Server switching', 'Application interface', 'Usually manual'],
							['Configuration files', 'May be handled by the app', 'Often required'],
							['Technical knowledge', 'Lower', 'Higher'],
							[
								'Linux flexibility',
								'Depends on supported distributions',
								'More configurable',
							],
						]
					),
					paragraph(
						"A dedicated application can be more convenient for users who don't want to manage VPN configuration files themselves."
					),
				],
			},
			{
				id: 'when-should-you-use-a-vpn-on-linux',
				title: 'When Should You Use a VPN on Linux?',
				blocks: [
					paragraph('A Linux VPN can be useful for everyday situations such as:'),
					unorderedList([
						'Using public Wi-Fi',
						'Working remotely',
						'Connecting from a hotel or caf\u00E9',
						'Traveling with a Linux laptop',
						'Protecting traffic on shared networks',
						'Hiding your public IP address',
						'Adding privacy to everyday browsing',
					]),
					paragraph(
						'A VPN is only one part of online security. Keep your Linux system updated and use strong passwords and other appropriate security measures.'
					),
				],
			},
			{
				id: 'secure-vpn-for-linux-laptops',
				title: 'Secure VPN for Linux Laptops',
				blocks: [
					paragraph(
						'A Linux laptop can move between home networks, office connections, public Wi-Fi, and mobile hotspots throughout the day.'
					),
					paragraph(
						'Instead of treating each network as trusted, you can use a VPN connection when additional privacy is useful.'
					),
					paragraph(
						'Secure VPN provides a central place to establish the connection, select an available server, and disconnect when the VPN is no longer needed.'
					),
				],
			},
			{
				id: 'secure-vpn-linux-download-requirements',
				title: 'Secure VPN Linux Download Requirements',
				blocks: [
					paragraph(
						'Before downloading and installing Secure VPN, check these basic points:'
					),
					unorderedList([
						'A compatible Linux distribution',
						'An active internet connection',
						'Sufficient storage for the application',
						'Permission to install software',
						'A supported system architecture',
						'A current version of the Secure VPN Linux package',
					]),
					paragraph(
						'Because Linux distributions can differ significantly, always use the installation method appropriate for your system.'
					),
				],
			},
		],
		faqs: [
			{
				question: 'Is Secure VPN available for Linux?',
				answer:
					'Secure VPN has a Linux platform page for users looking for VPN access on Linux computers. Availability may depend on the current software version and supported distributions.',
			},
			{
				question: 'How do I install Secure VPN on Linux?',
				answer:
					'Download the available Linux version and follow the installation instructions for your distribution. The exact process can differ between Ubuntu, Debian, Fedora, and other Linux systems.',
			},
			{
				question: 'Can I use Secure VPN on Ubuntu?',
				answer:
					'If the current Linux release supports your Ubuntu version and system architecture, you can install and use the available application.',
			},
			{
				question: 'Does Secure VPN hide my IP address?',
				answer:
					"When you're connected to a VPN server, your normal public IP is replaced by the VPN server's public IP address.",
			},
			{
				question: 'Can a Linux VPN protect public Wi-Fi?',
				answer:
					"A VPN can encrypt the VPN connection and provide an additional layer of protection when you're using shared Wi-Fi.",
			},
			{
				question: 'Do I need to configure a VPN manually on Linux?',
				answer:
					"Not necessarily. A compatible VPN application can simplify the setup process. Manual configuration is another option when an application doesn't support your particular Linux environment.",
			},
		],
	},
	android: {
		key: 'android',
		title: 'Secure VPN Download for Android \u2013 Free VPN APK',
		description:
			'Download Secure VPN for Android and protect your mobile connection with a private VPN. Get the Android VPN app and follow the simple installation steps.',
		keywords: 'Secure VPN Android, Android VPN APK, VPN app for Android, Secure VPN APK',
		hero: {
			title: 'Secure VPN Download for Android',
			description:
				'Secure VPN for Android gives you a simple way to protect your mobile connection and browse through a VPN server. Download the Android app, install it on your device, choose a server, and connect.',
			descriptionHtml:
				'<strong>Secure VPN for Android gives you a simple way to protect your mobile connection and browse through a VPN server. Download the Android app, install it on your device, choose a server, and connect.</strong>',
			ctaLabel: 'Get Secure VPN for Android',
			image: platformHeroImage('android'),
			imageAlt: 'Secure VPN app on Android',
		},
		sections: [
			{
				id: 'secure-vpn-for-android',
				title: '',
				blocks: [
					paragraph(
						'Your phone connects to many different networks throughout the day, from home Wi-Fi and mobile data to public hotspots in caf\u00E9s, airports, hotels, and other places.'
					),
					paragraph(
						'A VPN can add another layer of privacy by encrypting your connection and routing your traffic through a VPN server.'
					),
					paragraph(
						'Secure VPN for Android is designed to make that process straightforward. Instead of manually configuring VPN settings, you can install the Android app, select a location, and connect from your phone.'
					),
				],
			},
			{
				id: 'why-use-secure-vpn-on-android',
				title: 'Why Use Secure VPN on Android?',
				blocks: [
					heading('Protect Your Mobile Connection'),
					paragraph(
						"A VPN encrypts the connection between your Android device and the VPN server while you're connected, helping protect your traffic on shared networks."
					),
					heading('Hide Your IP Address'),
					paragraph(
						"When Secure VPN is connected, websites see the VPN server's public IP address rather than your regular public IP."
					),
					heading('Use Public Wi-Fi More Safely'),
					paragraph(
						"Public Wi-Fi can be convenient, but you don't always know who else is using the same network. A VPN provides an additional layer of protection when connecting through shared hotspots."
					),
					heading('Connect From Different Locations'),
					paragraph(
						'Secure VPN provides multiple server locations, allowing you to choose an available VPN server directly from the Android application.'
					),
				],
			},
			{
				id: 'secure-vpn-android-features',
				title: 'Secure VPN Android Features',
				blocks: [
					table(
						['Feature', 'Details'],
						[
							['Android Support', 'Designed for Android smartphones and tablets'],
							['VPN Encryption', 'Helps protect your connection'],
							['IP Address Masking', 'Replaces your public IP while connected'],
							['Multiple Locations', 'Choose from available VPN servers'],
							['Simple Interface', 'Easy connection controls'],
							['Public Wi-Fi Protection', 'Useful on shared networks'],
							['Mobile Friendly', 'Designed for everyday Android use'],
						]
					),
				],
			},
			{
				id: 'how-to-download-secure-vpn-for-android',
				title: 'How to Download Secure VPN for Android',
				blocks: [
					steps([
						{
							title: 'Download the Android App',
							text: "Tap the Download Secure VPN for Android button to access the available Android version. Make sure you're downloading the application from the official Secure VPN website rather than an unknown third-party source.",
							html: "Tap the <strong>Download Secure VPN for Android</strong> button to access the available Android version. Make sure you're downloading the application from the official Secure VPN website rather than an unknown third-party source.",
						},
						{
							title: 'Open the Downloaded File',
							text: 'After the APK has finished downloading, open the file from your Android notification panel or Downloads folder.',
						},
						{
							title: 'Allow Installation if Required',
							text: 'Depending on your Android version and where the APK was downloaded, Android may ask you to allow installation from that source. Only enable this permission when you trust the source of the application.',
						},
						{
							title: 'Install Secure VPN',
							text: 'Follow the Android installation prompts and wait for the application to finish installing.',
						},
						{
							title: 'Open Secure VPN',
							text: 'Launch the app and review the available VPN locations.',
						},
						{
							title: 'Choose a Server and Connect',
							text: 'Select a server location and tap Connect. Android may display a VPN connection permission prompt the first time you connect. Review the permission and confirm if you want to establish the VPN connection.',
							html: 'Select a server location and tap <strong>Connect</strong>. Android may display a VPN connection permission prompt the first time you connect. Review the permission and confirm if you want to establish the VPN connection.',
						},
					]),
				],
			},
			{
				id: 'secure-vpn-apk-for-android',
				title: 'Secure VPN APK for Android',
				blocks: [
					paragraph(
						'The Android version can be installed as an APK when that distribution method is provided.'
					),
					paragraph(
						"An APK is the installation package used by Android applications. If you're installing an APK outside Google Play, pay attention to where the file comes from and make sure you are using a legitimate download source."
					),
					paragraph('Before installing, check:'),
					unorderedList([
						'APK source',
						'App version',
						'Android compatibility',
						'Required permissions',
						'Available storage',
						'File authenticity when verification information is provided',
					]),
					paragraph(
						'Avoid downloading VPN APK files from unfamiliar download pages simply because they advertise a newer version.'
					),
				],
			},
			{
				id: 'secure-vpn-for-android-phones-and-tablets',
				title: 'Secure VPN for Android Phones and Tablets',
				blocks: [
					paragraph('Secure VPN can be useful on both Android phones and compatible tablets.'),
					paragraph(
						'On a phone, a VPN can remain useful as you switch between mobile data and different Wi-Fi networks. On a tablet, it can provide the same type of VPN connection when browsing, working, or using online services.'
					),
					paragraph(
						'The exact interface and available features can vary depending on the Android version and device.'
					),
				],
			},
			{
				id: 'when-should-you-use-a-vpn-on-android',
				title: 'When Should You Use a VPN on Android?',
				blocks: [
					paragraph(
						'There are several everyday situations where an Android VPN can be useful:'
					),
					unorderedList([
						'Connecting to public Wi-Fi',
						'Using hotel or airport Wi-Fi',
						'Working remotely',
						'Traveling with your phone',
						'Browsing on shared networks',
						'Protecting your public IP address',
						'Adding privacy to everyday internet use',
					]),
					paragraph(
						'A VPN does not make your device completely anonymous or replace Android security features, antivirus protection, or safe browsing practices.'
					),
				],
			},
			{
				id: 'secure-vpn-on-wi-fi-and-mobile-data',
				title: 'Secure VPN on Wi-Fi and Mobile Data',
				blocks: [
					paragraph(
						'A useful feature of a mobile VPN is that you can use it across different types of internet connections.'
					),
					heading('Wi-Fi'),
					paragraph(
						'When connected to a home, hotel, caf\u00E9, or public Wi-Fi network, Secure VPN can provide an additional layer of protection through its VPN connection.'
					),
					heading('Mobile Data'),
					paragraph(
						'You can also use a VPN while connected through your mobile carrier. This can help maintain the same VPN connection approach when switching away from Wi-Fi.'
					),
				],
			},
			{
				id: 'secure-vpn-vs-android-proxy',
				title: 'Secure VPN vs. Android Proxy',
				blocks: [
					paragraph(
						"VPNs and proxies can both change the apparent IP address of a connection, but they aren't identical."
					),
					table(
						['', 'Secure VPN', 'Proxy'],
						[
							['Android app', 'Yes', 'Depends on service'],
							['Encrypts VPN connection', 'Yes', 'Depends on proxy'],
							['IP address masking', 'Yes', 'Yes'],
							['Device-wide VPN connection', 'Supported', 'Usually more limited'],
							['Setup', 'App-based', 'Can require manual settings'],
						]
					),
					paragraph(
						'For Android users who want a straightforward setup, a dedicated VPN application can be easier than configuring proxy settings manually.'
					),
				],
			},
			{
				id: 'secure-vpn-android-requirements',
				title: 'Secure VPN Android Requirements',
				blocks: [
					paragraph(
						'Before installing the Android version, check the current requirements for the available release.'
					),
					paragraph('Your device should have:'),
					unorderedList([
						'A compatible Android version',
						'An active internet connection',
						'Enough free storage',
						'Permission to install the application',
						'A supported device architecture',
					]),
					paragraph(
						'Android settings and installation prompts can differ between manufacturers, so the exact steps may vary on Samsung, Google Pixel, Xiaomi, OnePlus, and other devices.'
					),
				],
			},
		],
		faqs: [
			{
				question: 'Is Secure VPN available for Android?',
				answer:
					'Yes. Secure VPN provides an Android option for users who want to connect their mobile devices through a VPN.',
			},
			{
				question: 'Where can I download Secure VPN for Android?',
				answer:
					'Use the Secure VPN Android download page to access the available version. Check the source and version information before installing an APK.',
			},
			{
				question: 'How do I install Secure VPN APK?',
				answer:
					'Download the APK, open the file, allow installation from the relevant source if Android requests permission, and follow the installation prompts.',
			},
			{
				question: 'Can I use Secure VPN on Android without Wi-Fi?',
				answer:
					'Yes. A VPN can also operate over mobile data as long as your device has an active internet connection.',
			},
			{
				question: 'Does Secure VPN hide my Android IP address?',
				answer:
					"When connected to a VPN server, your normal public IP address is replaced by the VPN server's public IP address.",
			},
			{
				question: 'Can I use Secure VPN on public Wi-Fi?',
				answer:
					"Yes. A VPN can provide an additional layer of protection when you're connected to shared Wi-Fi networks.",
			},
			{
				question: 'Is an Android VPN completely anonymous?',
				answer:
					"No. A VPN can improve connection privacy and hide your public IP, but it doesn't prevent all forms of online tracking or identify protection by itself.",
			},
		],
	},
	ios: {
		key: 'ios',
		title: 'Secure VPN Download for iOS \u2013 Free VPN for iPhone & iPad',
		description:
			'Download Secure VPN for iOS and protect your iPhone or iPad connection. Set up a private VPN, choose a server, and connect in a few simple steps.',
		keywords: 'Secure VPN iOS, VPN for iPhone, VPN for iPad, iOS VPN download',
		hero: {
			title: 'Secure VPN Download for iOS',
			description:
				'Secure VPN for iOS gives iPhone and iPad users a simple way to connect through a private VPN server. Install the app, choose an available location, and connect to protect your internet connection.',
			descriptionHtml:
				'<strong>Secure VPN for iOS gives iPhone and iPad users a simple way to connect through a private VPN server. Install the app, choose an available location, and connect to protect your internet connection.</strong>',
			ctaLabel: 'Get Secure VPN for iOS',
			image: platformHeroImage('ios'),
			imageAlt: 'Secure VPN connected on iPhone',
		},
		sections: [
			{
				id: 'secure-vpn-for-iphone-and-ipad',
				title: 'Secure VPN for iPhone and iPad',
				blocks: [
					paragraph(
						'Your iPhone or iPad may connect to different networks throughout the day, including home Wi-Fi, mobile data, public hotspots, and hotel networks.'
					),
					paragraph(
						'A VPN can add another layer of privacy by encrypting your connection and routing traffic through a VPN server.'
					),
					paragraph(
						'Secure VPN provides a straightforward way to establish a VPN connection on iOS without requiring users to manually configure complicated network settings.'
					),
					paragraph(
						"Whether you're browsing on an iPhone or using an iPad for work, streaming, or everyday browsing, you can connect to an available VPN server directly from the app."
					),
				],
			},
			{
				id: 'why-use-secure-vpn-on-ios',
				title: 'Why Use Secure VPN on iOS?',
				blocks: [
					heading('Protect Your Connection'),
					paragraph(
						"A VPN encrypts your connection while you're connected to the VPN server, helping provide additional protection when using shared networks."
					),
					heading('Hide Your Public IP'),
					paragraph(
						'When connected to Secure VPN, your public IP address is replaced by the IP address of the VPN server.'
					),
					heading('Use Public Wi-Fi More Privately'),
					paragraph(
						'Airports, hotels, caf\u00E9s, and other public locations often provide shared Wi-Fi. A VPN can provide an additional layer of protection when connecting through these networks.'
					),
					heading('Switch Between VPN Locations'),
					paragraph(
						'Secure VPN provides multiple available server locations, allowing you to select a location from the iOS application.'
					),
				],
			},
			{
				id: 'secure-vpn-ios-features',
				title: 'Secure VPN iOS Features',
				blocks: [
					table(
						['Feature', 'Details'],
						[
							['iOS Support', 'Designed for compatible iPhone and iPad devices'],
							['VPN Encryption', 'Helps protect your connection'],
							['IP Address Masking', 'Replaces your public IP while connected'],
							['Multiple Locations', 'Select from available VPN servers'],
							['Simple Connection', 'Connect through the mobile app'],
							['Public Wi-Fi Protection', 'Useful when using shared networks'],
							[
								'iPhone & iPad',
								'Suitable for supported iOS and iPadOS devices',
							],
						]
					),
				],
			},
			{
				id: 'how-to-download-secure-vpn-for-iphone',
				title: 'How to Download Secure VPN for iPhone',
				blocks: [
					steps([
						{
							title: 'Open the iOS Download Page',
							text: 'Tap the Download Secure VPN for iOS button to access the available iOS version.',
							html: 'Tap the <strong>Download Secure VPN for iOS</strong> button to access the available iOS version.',
						},
						{
							title: 'Install the App',
							text: 'Follow the installation instructions for your iPhone or iPad. If Secure VPN is distributed through the App Store, open its App Store listing and tap Get to install the application.',
							html: 'Follow the installation instructions for your iPhone or iPad. If Secure VPN is distributed through the App Store, open its App Store listing and tap <strong>Get</strong> to install the application.',
						},
						{
							title: 'Open Secure VPN',
							text: 'Once installation is complete, launch Secure VPN from your iPhone or iPad.',
						},
						{
							title: 'Allow VPN Configuration',
							text: 'The first time you establish a VPN connection, iOS may ask you to allow the application to add a VPN configuration. Review the request and approve it if you want to use the VPN connection.',
						},
						{
							title: 'Choose a Server',
							text: 'Open the server list and select an available VPN location.',
						},
						{
							title: 'Connect',
							text: 'Tap Connect and wait for the VPN connection to become active. A VPN indicator may appear in the iOS status area when the connection is active.',
							html: 'Tap <strong>Connect</strong> and wait for the VPN connection to become active. A VPN indicator may appear in the iOS status area when the connection is active.',
						},
					]),
				],
			},
			{
				id: 'secure-vpn-for-iphone',
				title: 'Secure VPN for iPhone',
				blocks: [
					paragraph(
						'A VPN can be particularly useful on an iPhone because the device frequently moves between different networks.'
					),
					paragraph(
						'You might use your iPhone on home Wi-Fi in the morning, mobile data while traveling, and public Wi-Fi later in the day.'
					),
					paragraph(
						'Secure VPN gives you a simple way to establish a VPN connection whenever you want additional privacy while browsing or using online services.'
					),
				],
			},
			{
				id: 'secure-vpn-for-ipad',
				title: 'Secure VPN for iPad',
				blocks: [
					paragraph('The same VPN approach can be useful on an iPad.'),
					paragraph(
						"Whether you're using an iPad for browsing, remote work, streaming, or connecting to public Wi-Fi, Secure VPN can route your connection through an available VPN server."
					),
					paragraph(
						'The exact interface may vary depending on your iPadOS version and the current application release.'
					),
				],
			},
			{
				id: 'when-should-you-use-a-vpn-on-iphone',
				title: 'When Should You Use a VPN on iPhone?',
				blocks: [
					paragraph('An iPhone VPN can be useful in everyday situations such as:'),
					unorderedList([
						'Using airport Wi-Fi',
						'Connecting at a hotel',
						'Browsing from a caf\u00E9',
						'Working remotely',
						'Traveling internationally',
						'Using shared Wi-Fi',
						'Protecting your public IP address',
						'Adding privacy to everyday browsing',
					]),
					paragraph(
						'A VPN is not a replacement for iOS security features, strong passwords, or safe browsing habits. It works as an additional privacy and connection layer.'
					),
				],
			},
			{
				id: 'vpn-on-wi-fi-and-mobile-data',
				title: 'VPN on Wi-Fi and Mobile Data',
				blocks: [
					paragraph(
						'Secure VPN can be used while your iPhone or iPad has an active internet connection.'
					),
					heading('Wi-Fi'),
					paragraph(
						"When you're connected to home or public Wi-Fi, a VPN can encrypt the VPN connection and provide additional protection on shared networks."
					),
					heading('Mobile Data'),
					paragraph(
						"You can also connect to a VPN while using cellular data. This allows you to maintain a VPN connection when you're away from Wi-Fi."
					),
				],
			},
			{
				id: 'secure-vpn-vs-ios-proxy',
				title: 'Secure VPN vs. iOS Proxy',
				blocks: [
					paragraph(
						'VPNs and proxies can both change the IP address visible to websites, but their operation is different.'
					),
					table(
						['', 'Secure VPN', 'Proxy'],
						[
							['iPhone support', 'Yes', 'Depends on service'],
							['iPad support', 'Yes', 'Depends on service'],
							['VPN encryption', 'Yes', 'Depends on proxy'],
							['IP masking', 'Yes', 'Yes'],
							['App-based setup', 'Yes', 'Often manual'],
							['Device connection', 'VPN connection', 'Usually more limited'],
						]
					),
					paragraph(
						'For users who want a simple mobile setup, a dedicated VPN application can be easier than manually configuring proxy settings.'
					),
				],
			},
			{
				id: 'secure-vpn-ios-requirements',
				title: 'Secure VPN iOS Requirements',
				blocks: [
					paragraph(
						'Before installing Secure VPN, check the requirements of the current iOS application.'
					),
					paragraph('Your device should have:'),
					unorderedList([
						'A compatible iOS or iPadOS version',
						'An active internet connection',
						'Enough available storage',
						'Permission to establish a VPN configuration',
						'A supported iPhone or iPad',
					]),
					paragraph(
						'Because Apple regularly updates iOS and iPadOS, the exact installation interface can change between system versions.'
					),
				],
			},
		],
		faqs: [
			{
				question: 'Is Secure VPN available for iPhone?',
				answer:
					'Yes. Secure VPN provides an iOS option for users who want to connect their iPhone through a VPN server.',
			},
			{
				question: 'Can I use Secure VPN on iPad?',
				answer:
					'Yes. Compatible iPad devices can use the iOS/iPadOS version when supported by the current application.',
			},
			{
				question: 'How do I install Secure VPN on iPhone?',
				answer:
					'Download the available iOS application, install it on your iPhone, open Secure VPN, approve the VPN configuration request, select a server, and connect.',
			},
			{
				question: 'Does Secure VPN hide my iPhone IP address?',
				answer:
					"When you're connected to a VPN server, your regular public IP address is replaced by the VPN server's public IP.",
			},
			{
				question: 'Can I use Secure VPN with mobile data?',
				answer:
					'Yes. A VPN can be used over an active cellular data connection as well as Wi-Fi.',
			},
			{
				question: 'Can I use Secure VPN on public Wi-Fi?',
				answer:
					'Yes. A VPN can provide an additional layer of protection when your iPhone or iPad is connected to shared Wi-Fi.',
			},
			{
				question: 'Does an iPhone VPN make me completely anonymous?',
				answer:
					'No. A VPN can hide your public IP address and protect the VPN connection, but it does not prevent every form of online tracking.',
			},
		],
	},
};
